var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSipSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "All mutualfunds"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": 76351
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3323",
    d: "M22.579 23.379a1.175 1.175 0 00-.281 1.64c.377.532 1.839 1.681 2.369 1.307s-.069-2.135-.446-2.666a1.175 1.175 0 00-1.642-.281z",
    fill: "#97144d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3324",
    d: "M10.59 30.27a1.52 1.52 0 002.126.3c.67-.5 2.1-2.431 1.6-3.1s-2.751.169-3.421.674a1.517 1.517 0 00-.305 2.126z",
    fill: "#97144d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3325",
    d: "M9.623 23.302a1.141 1.141 0 10.459 2.235c.617-.126 2.206-.974 2.081-1.592s-1.918-.77-2.54-.643z",
    fill: "#97144d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3326",
    d: "M17.102 30.518c-.516-.27-1.616.8-2.014 1.409h2.26c.089-.618.064-1.249-.246-1.409z",
    fill: "#97144d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3327",
    d: "M42.988 23.421a5.225 5.225 0 00-5.664-1.987 8.256 8.256 0 012.694-3.24 1.309 1.309 0 00-1.5-2.144 10.82 10.82 0 00-3.78 4.876 5.493 5.493 0 00-3.18-.673 7.688 7.688 0 00-.657-.654 15.624 15.624 0 01-4.508-6.678 4.666 4.666 0 00-4.408-3.145c-.07 0-.139.014-.209.017a6.01 6.01 0 00-2.668-3.318 5.238 5.238 0 00-4-.359 1.309 1.309 0 10.858 2.473 2.684 2.684 0 011.894.191 3.426 3.426 0 011.45 1.857 4.655 4.655 0 00-1.744 5.32 15.626 15.626 0 01.568 8.037 7.652 7.652 0 00-.1.771l-6.117-8.136a2.391 2.391 0 00-1.769-.951l-.144-.005a2.416 2.416 0 00-1.725.731 12.558 12.558 0 00-1.603 15.523h3.286c-.211-.233-.42-.469-.612-.724a9.961 9.961 0 01.637-12.793l10.161 13.517h7.908a7.278 7.278 0 012.5-8.631 2.618 2.618 0 011.544-.5 2.656 2.656 0 011.954.86 2.734 2.734 0 001.581.908c.061.01.123.007.185.012h.04a2.811 2.811 0 001.567-.381 2.7 2.7 0 013.433.756 7.3 7.3 0 011.294 5.463 7.422 7.422 0 01-.426 1.511h.421a4.4 4.4 0 012.171.577 10.153 10.153 0 00.42-1.671 9.9 9.9 0 00-1.752-7.41zm-17.957 4.241a10.022 10.022 0 00-.046 2.856 5.159 5.159 0 01-4.093-3.416 5.081 5.081 0 01-.184-2.613 18.254 18.254 0 00-.658-9.386 2.047 2.047 0 011.268-2.6 2.022 2.022 0 01.667-.112 2.047 2.047 0 011.934 1.383 18.231 18.231 0 004.973 7.509 9.889 9.889 0 00-3.861 6.379z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3328",
    d: "M32.944 30.742c.362-.574.889-2.439.316-2.8s-2.03.918-2.392 1.491a1.228 1.228 0 002.076 1.31z",
    fill: "#97144d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3329",
    d: "M38.218 31.927a1.223 1.223 0 00.425-1.245c-.164-.657-1.146-2.329-1.8-2.166s-.742 2.1-.579 2.759a1.2 1.2 0 00.445.652h1.512z",
    fill: "#97144d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3330",
    d: "M42.153 34.546H6.604a1.788 1.788 0 00-1.485 2.785l2.746 4.1a4.911 4.911 0 004.08 2.176h24.963a4.913 4.913 0 004.124-2.244l2.623-4.052a1.788 1.788 0 00-1.5-2.76z",
    fill: "#97144d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 131",
    fill: "#97144d",
    stroke: "#f6f7f8",
    strokeWidth: 2,
    transform: "translate(33 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon / Done / Black",
    d: "M42.739 16.087l-2.792-2.792-.947.947 3.739 3.739 8.034-8.034L49.826 9z",
    fill: "#fff"
  }))));
}
export default SvgSipSuccess;